import moment from 'moment'
import { dateToShow, dateToMysql } from '@/helpers/dates'
import { get, filter, map, find } from 'lodash'
import { status } from './dataStatus'

const types = {
  clinic: 'Clínica Médica',
  office: 'Consultório médico',
  'emergency_room': 'Emergência',
  laboratory: 'Labotarório',
  others: 'Outros'
}

const prepareSearch = search => {
  search.date_start = dateToMysql(search.date_start, 'YYYY-MM-DD 00:00:00')
  search.date_end = dateToMysql(search.date_end, 'YYYY-MM-DD 23:59:59')

  return search
}

const parseType = (type) => {
  return get(types, type.type, 'Outros')
}

const prepareShow = schedule => {
  const isAfter = moment(schedule.date).isAfter(moment().format('YYYY-MM-DD'))

  if (isAfter) {
    schedule._status = get(status, schedule.status, schedule.status)
  }

  // se schedule.date for uma da anterior da data atual.
  if (!isAfter) {
    schedule._status = 'Indefinida'
  }

  schedule._selected = false
  schedule.time = moment(schedule.date).format('HH:mm')
  schedule.date = dateToShow(schedule.date)
  schedule.weekday = moment(schedule.weekday).format('YYYY-MM-DD')
  schedule.company_type = parseType(schedule.agenda.address.company)

  return schedule
}

export default {
  prepareShow,
  prepareSearch,
  selectAll () {
    const schedules = map(this.schedules, schedule => {
      if (schedule.status !== 'canceled') {
        schedule._selected = this.all
      }

      return schedule
    })

    this.schedules = [...schedules]
  },
  onCloseCancel (schedules) {
    const data = filter(this.schedules, (schedule) => {
      return !find(schedules, {id: schedule.id})
    })

    this.schedules = [...data]
    this.showModalCancel = false
    this.all = false
  },
  onCloseReverser (schedule) {
    const data = filter(this.schedules, (item) => {
      return schedule.id !== item.id
    })

    this.schedules = [...data]
    this.showModalReverser = false
  },
  onCloseTransfer (schedule) {
    const data = filter(this.schedules, (item) => {
      return schedule.id !== item.id
    })

    this.schedules = [...data]
    this.showModalTransfer = false
  },
  hideShowModalCancel () {
    this.showModalCancel = false
  },
  hideShowModalReverser () {
    this.showModalReverser = false
  },
  hideShowModalTransfer () {
    this.showModalTransfer = false
  },

  doCancel (schedule = {}, all = true) {
    if (all) {
      this.schedulesSelected = this.schedules.filter((schedule) => {
        return schedule._selected
      })
    } else {
      this.schedulesSelected = [{...schedule}]
    }
    this.showModalCancel = true
  },
  doReverser (schedule) {
    this.currentSchedule = {...schedule}
    this.showModalReverser = true
  },
  doTransfer (schedule) {
    this.currentSchedule = {...schedule}
    this.showModalTransfer = true
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/scheduled/index/resources/methods.js